import styled, { css } from 'styled-components'

import { Link as DefaultLink } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isActive: boolean
}

export const Link = styled(DefaultLink)<Props>`
	display: block;
	width: fit-content;
	color: ${helpers.color.textMuted};
	padding: 1px 4px;
	border-radius: 4px;
	margin: -1px 0;

	&:hover {
		text-decoration: none;
		color: ${helpers.color.link};
		background-color: ${helpers.color.linkBackgroundHover};
	}

	&:active,
	&:focus {
		text-decoration: none;
		color: ${helpers.color.text};
	}

	${({ isActive }) =>
		isActive &&
		css`
		color: ${helpers.color.link};
		background-color: ${helpers.color.linkBackgroundHover};
	`}
`
